import Vue from "vue";
import VueRouter from "vue-router";
import MainPage from "../views/MainPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "MainPage",
    component: MainPage
  },
  {
    path: "/kontakt",
    name: "Contact",
    component: () => import("../views/Contact.vue")
  },
  {
    path: "/baza-wiedzy",
    name: "KnowledgeBase",
    component: () => import("../views/KnowledgeBase.vue")
  },

  {
    path: "/gdzie-nas-znalezc",
    name: "Outpost",
    component: () => import("../views/Outpost.vue")
  },
  {
    path: "/realizacje",
    name: "Project",
    component: () => import("../views/Projects.vue")
  },
  {
    path: "/kolekcja",
    name: "Collection",
    component: () => import("../views/Collections.vue")
  },
  {
    path: "/pielegnacja",
    name: "Maintenance",
    component: () => import("../views/offer/Maintenance.vue")
  },
  {
    path: "/handmade",
    name: "Handmade",
    component: () => import("../views/offer/Handmade.vue")
  },
  {
    path: "/oleje",
    name: "Oil",
    component: () => import("../views/offer/Oil.vue")
  },
  {
    path: "/podlogi",
    name: "Floor",
    component: () => import("../views/offer/Floor.vue")
  },
  {
    path: "/kolekcja/klasyczna",
    name: "Classic",
    component: () => import("../views/collections/Classic.vue")
  },
  {
    path: "/kolekcja/stylizowana",
    name: "Styled",
    component: () => import("../views/collections/Styled.vue")
  },
  {
    path: "/kolekcja/stare-deby",
    name: "OldOak",
    component: () => import("../views/collections/OldOak.vue")
  },
  {
    path: "/kolekcja/antyczna",
    name: "Antic",
    component: () => import("../views/collections/Antic.vue")
  },
  {
    path: "/kolekcja/dworska",
    name: "Aulic",
    component: () => import("../views/collections/Aulic.vue")
  },
  {
    path: "/kolekcja/glamour",
    name: "Glamour",
    component: () => import("../views/collections/Glamour.vue")
  },
  {
    path: "/kolekcja/nobilium",
    name: "Nobilium",
    component: () => import("../views/collections/Nobilium.vue")
  },
  {
    path: "/kolekcja/champions",
    name: "Champions",
    component: () => import("../views/collections/Champions.vue")
  },
  {
    path: "/aktualnosci",
    name: "News",
    component: () => import("../views/News.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  hash: false,
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(function(to, from, next) {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 500);

  next();
});

export default router;
